import { forwardRef, Ref, useImperativeHandle, useRef, useState } from "react";

export interface OverlayShowHideRef {
  onMouseMove: () => void;
}

interface Props {
  isFullScreen: boolean;
  children: React.ReactNode;
}

const OverlayShowHide = forwardRef(
  (props: Props, ref: Ref<OverlayShowHideRef>) => {
    const { isFullScreen, children } = props;

    useImperativeHandle(ref, () => ({ onMouseMove }));

    const [isFullScreenOverlayVisible, setIsFullScreenOverlayVisible] =
      useState<boolean>(false);

    const fullScreenOverlayTimeoutRef = useRef<ReturnType<
      typeof setTimeout
    > | null>(null);

    const onMouseMove = () => {
      const onMouseMoveFullScreen = () => {
        setIsFullScreenOverlayVisible(true);

        if (fullScreenOverlayTimeoutRef.current) {
          clearTimeout(fullScreenOverlayTimeoutRef.current);
        }

        fullScreenOverlayTimeoutRef.current = setTimeout(() => {
          setIsFullScreenOverlayVisible(false);
        }, 3000);
      };

      if (isFullScreen) {
        onMouseMoveFullScreen();
      }
    };

    return (
      <div
        className={`overlay-showhide ${isFullScreenOverlayVisible ? "show" : "hide"}`}
        style={{ position: "relative", zIndex: 2 }}
      >
        {children}
      </div>
    );
  },
);

export default OverlayShowHide;
